import pageContent from './service';
export default {
    pageContent
};